export const DndTypes = {
  BOX: 'box',
};
